import React, { useEffect, useState } from 'react';
import { observer, inject } from 'mobx-react';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { PopupOption as UIPopupOption } from '@shopee/chatbot-ui';
import { RadioValue } from '@shopee/chatbot-ui/lib/components/Radio';
import FailToLoad from '@/assets/img/fail_to_load.svg';
import { ButtonAction } from '@/utils/getButtonData';
import { jsonParse } from '@/utils/jsonParse';
import API from '@/services';
import { InitStoreType } from '@/types/store/init';
import { getTrans } from '@/utils/tools';
import {
  CONTACT_METHOD_MAP,
  ContactMethod,
  DELIVERY_INSTRUCTION_MAP,
  Delivery,
  DeliveryInstructionType,
  INPUT_TYPE,
  TRACKING_MSG_TYPE,
  TRACKING_OPERATION,
  TRACKING_PAGE,
  TRACKING_SECTION,
  TRACKING_TARGET,
} from '@/utils/constants';
import { addDialogue, updateDialogueInfo } from '@/utils/sessionUtils';
import { DIALOGUE_TYPE, ChatbotUIBasicProps } from '@/types/common';
import { next } from '@/utils/next';
import { USER_SEND_TYPE } from '@/types/history';
import { dispatchTrack } from '@/utils/tracking';

export type DeliveryInstructionsProps = {
  taskbotInfo: any;
  action: {
    action_type: ButtonAction;
    task_bot_action: any;
  };
  popup: {
    title: string;
  };
  options: {
    label: string;
    value: number | string;
  }[][];
  // reqParams: any;
  orderShopInfo: any;
} & {
  initStore: InitStoreType;
  dialogueId: string;
  dialogueType: any;
  threadNodeId: string;
  threadId: string;
  threadIdV2: string;
  roundId: string;
  listPos: number;
  cardPosition: number; // 对应卡片的位置
} & ChatbotUIBasicProps;
const DeliveryInstructions: React.FC<DeliveryInstructionsProps> = (props) => {
  const {
    popup,
    orderShopInfo,
  } = props;
  console.log('props', props);

  const [footerText, setFooterText] = useState('');
  const [options, setOptions] = useState<{
    label: string;
    value: number | string;
  }[][]>([]);
  const [selectedOptions, setSelectedOptions] = useState<any[]>([]);

  const params = {
    dialogue_id: props.dialogueId,
    session_id: props.initStore.sessionId,
    thread_id: props.threadId,
    api_key: 'query_sls_delivery_instruction',
    query_data: JSON.stringify(props?.orderShopInfo),
  };

  const [popupActive, setPopupActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [multiOptionsList, setMultiOptionsList] = useState<any[]>([]);
  const [customerElement, setCustomerElement] = useState<any>(undefined);
  const [isFirstSubmit, setIsFirstSubmit] = useState(false);
  const [optionsLabel, setOptionsLable] = useState<string>();

  const getInstructionLabel = (selectedList: any[]) => {
    const labelMapList: any[] = [DELIVERY_INSTRUCTION_MAP, CONTACT_METHOD_MAP];

    const label = selectedList
      ?.map(
        (item, index) =>
          getTrans(labelMapList[index][item]) || labelMapList[index][item],
      )
      .filter((item) => item !== undefined)
      .join(', ');
    return label?.length ? label : '--';
  };

  // 可展示的 options
  const deliveryInstructionsOptionsList = [DeliveryInstructionType.LeaveAtDoorstep, DeliveryInstructionType.LeaveAtReception];
  const contactMethodOptionsList = [ContactMethod.CallBeforeDelivery];

  const trackingParams = {
    page: TRACKING_PAGE.MAIN_PAGE,
    operation: TRACKING_OPERATION.IMPRESSION,
    target: TRACKING_TARGET.deliveryInstructionField,
    section: TRACKING_SECTION.deliveryInstruction,
  };
  const trackingData = {
    chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
    chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
    if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    bot_id: props.taskbotInfo?.bot_id,
    intent_id: props.taskbotInfo?.intent_id,
    field_title: popup?.title,
  };

  useEffect(() => {
    (API as { getDeliveryInstructions: Function })
      .getDeliveryInstructions(params)
      .then((res: any) => {
        const data = jsonParse(res);

        // 返回数据中可展示的 available options
        const availableDeliveryInstructions = data?.available_delivery_instructions?.filter(
          (item: DeliveryInstructionType) => deliveryInstructionsOptionsList.includes(item),
        );
        const availableContactMethod = data?.available_contact_method?.filter(
          (item: ContactMethod) => contactMethodOptionsList.includes(item),
        );

        // 返回数据中可展示的 selected options
        const selectedDeliveryInstructions = data?.select_delivery_instructions?.filter(
          (item: DeliveryInstructionType) => deliveryInstructionsOptionsList.includes(item),
        )?.[0] ?? undefined;

        const selectedContactMethod = data?.select_contact_method?.filter(
          (item: ContactMethod) => contactMethodOptionsList.includes(item),
        )?.[0] ?? undefined;

        // 选择项
        const deliveryInstructionsOptions = availableDeliveryInstructions?.map(
          (item: DeliveryInstructionType) => ({
            label: getTrans(DELIVERY_INSTRUCTION_MAP[item]) || DELIVERY_INSTRUCTION_MAP[item],
            value: item,
          }),
        );
        const contactMethodOptions = availableContactMethod?.map((item: ContactMethod) => ({
          label: getTrans(CONTACT_METHOD_MAP[item]) || CONTACT_METHOD_MAP[item],
          value: item,
        }));

        let footerText = '';
        if (availableDeliveryInstructions.length || availableContactMethod?.length) {
          if (!selectedDeliveryInstructions && !selectedContactMethod) {
            footerText = getTrans(Delivery.BTN_SUBMIT);
            setIsFirstSubmit(true);
          } else {
            footerText = getTrans(Delivery.BTN_CONFIRM_CHANGES);
          }
        }
        const selectedList = [selectedDeliveryInstructions, selectedContactMethod];

        setPopupActive(true);
        // view only
        !footerText?.length && setCustomerElement(viewElement(getInstructionLabel(selectedList)));
        // set or change
        setFooterText(footerText);
        setOptions([deliveryInstructionsOptions, contactMethodOptions]);
        setSelectedOptions(selectedList);
        setMultiOptionsList(selectedList);


        const optionsLabel = [
          ...availableDeliveryInstructions?.map((item: DeliveryInstructionType) => getTrans((DELIVERY_INSTRUCTION_MAP)[item])),
          ...availableContactMethod?.map((item: ContactMethod) => getTrans(CONTACT_METHOD_MAP[item]))]?.join(',');
        setOptionsLable(optionsLabel);
        dispatchTrack({
          ...trackingParams, data: {
            ...trackingData,
            field_name: optionsLabel,
          },
        });
      })
      .catch(() => {
        setCustomerElement(viewElement(getInstructionLabel([])));
        dispatchTrack({
          ...trackingParams, data: {
            ...trackingData,
            field_name: getInstructionLabel([]),
          },
        });
      });
  }, []);

  const optionsParmas = (noBorder: boolean) => {
    return {
      isButtonRight: true,
      className: noBorder ? 'delivery-option-no-border' : 'delivery-option',
    };
  };

  const errorElement = (errText: string) => (
    <div className="error-container">
      <img className="error-image" src={FailToLoad} />
      <div className="error-text">{errText}</div>
    </div>
  );
  const viewElement = (text: string) => (
    <div className="view-delivery-instruction">
      <div className="view-title">{getTrans(Delivery.DELIVERY_INSTRUCTION)}</div>
      <div className="view-content">{text}</div>
    </div>
  );

  return (
    <UIPopupOption
      showConfirm={false}
      popupProps={{
        active: popupActive,
        title: popup?.title,
        onClose: () => {
          setPopupActive(false);
        },
        className: 'delivery-instructions-popup',
      }}
      groupClassName="groups-container"
      multiRadioGroupProps={options?.map((option, index) => ({
        value: multiOptionsList[index],
        options: option?.map((item, optionIndex) => {
          return {
            ...item,
            ...optionsParmas(optionIndex === option?.length - 1),
          };
        }),
        className: index > 0 ? 'radio-group-wrapper' : '',
        layout: 'vertical',
        onChange: (changedVal: RadioValue) => {
          setMultiOptionsList((prevList) => {
            // 设置对应index的option
            return prevList.map((prevValue, i) => (i === index ? Number(changedVal) : prevValue));
          });
        },
        onRadioClick: (changedVal: RadioValue) => {
          setMultiOptionsList((prevList) => {
            // 点击选中再点取消
            const newValue = Number(changedVal) === multiOptionsList.at(index) ? undefined : changedVal;
            // 设置对应index的option
            return prevList.map((prevValue, i) => (i === index ? newValue : prevValue));
          });
        },
      }))}
      customerElement={customerElement}
      footerProps={{
        disabled: multiOptionsList.every((item, index) => item === selectedOptions[index]),
        text: footerText,
        loading,
        style: { margin: '12px', lineHeight: '20px', padding: '12px 16px', fontSize: '16px' },
        onClick: () => {
          setLoading(true);
          dispatchTrack({
            ...trackingParams,
            operation: TRACKING_OPERATION.CLICK,
            data: {
              ...trackingData,
              field_name: optionsLabel,
            },
          });

          (API as { updateDeliveryInstructions: Function })
            .updateDeliveryInstructions({
              ...params,
              api_key: 'update_delivery_instruction',
              query_data: JSON.stringify({
                ...orderShopInfo,
                select_delivery_instructions: multiOptionsList.at(0) ? [multiOptionsList.at(0)] : [],
                select_contact_method: multiOptionsList.at(1) ? [multiOptionsList.at(1)] : [],
              }),
            })
            .then((res: any) => {
              const data = jsonParse(res);

              if (data?.is_update_delivery_instruction_success) {
                setPopupActive(false);
                // deliveryInstructions成功提交后需要禁止点击
                updateDialogueInfo({ isSubmitDeliveryInstructions: true }, props.cardPosition);
                addDialogue({
                  dialogueId: props?.dialogueId,
                  dialogueType: props?.dialogueType,
                  from: 'user',
                  type: DIALOGUE_TYPE.TFEDeliveryInstructionCard,
                  data: {
                    title: isFirstSubmit ? getTrans(Delivery.SUBMITTED_SUCCECSSFULLY) : getTrans(Delivery.CHANGED_SUCCESSFULLY),
                    subTitle: `${getTrans(Delivery.DELIVERY_INSTRUCTION)}:`,
                    instructions: getInstructionLabel(multiOptionsList),
                    trackingData,
                  },
                });
                const title = isFirstSubmit ? getTrans(Delivery.SUBMITTED_SUCCECSSFULLY) : getTrans(Delivery.CHANGED_SUCCESSFULLY);
                const subTitle = getTrans(Delivery.DELIVERY_INSTRUCTION);
                const instructions = getInstructionLabel(multiOptionsList);
                const nextParams = {
                  message_text: 'submit',
                  input_type: INPUT_TYPE.BUTTON,
                  session_id: props.initStore.sessionId,
                  dialogue_id: props.dialogueId,
                  thread_node_id: props.threadNodeId,
                  thread_id: props.threadId,
                  thread_id_v2: props.threadIdV2,
                  round_id: props.roundId,
                  title,
                  subTitle: `${subTitle}:`,
                  instructions,
                  isUpdate: data?.is_update_delivery_instruction_success,
                  message_extra: {
                    params: {
                      user_send: {
                        type: USER_SEND_TYPE.TEXT,
                        text: `${title} - ${subTitle}: ${instructions}`,
                      },
                    },
                    task_bot_action: {
                      ...(props?.action?.task_bot_action || {}),
                      task_bot_info: props.taskbotInfo,
                    },
                  },
                };
                next({ ...nextParams });
              } else {
                setCustomerElement(errorElement(getTrans(Delivery.UNSUCESSFUL_WEBFORM_SUBMISSION)));
              }
            })
            .catch(() => {
              setCustomerElement(errorElement(getTrans(Delivery.UNSUCESSFUL_WEBFORM_SUBMISSION)));
            });
        },
      }}
    />
  );
};

export default inject(getChildInject('initStore'))(observer(DeliveryInstructions));
